var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ordit-logo",style:({ width: _vm.width })},[_c('img',{attrs:{"src":"/img/ordit_logo.svg","alt":"Ordit logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }